export default "/images/padlock.svg?427625da24f388011433888a31a81b06";